import { createContext } from 'react';

import type { CombinedNotificationsResponse } from './useCombinedNotifications';

const CombinedNotificationsContext = createContext<CombinedNotificationsResponse>({
  combinedNotificationsResponse: undefined,
});

export default CombinedNotificationsContext;
